export default __webpack_public_path__ + "static/media/background3-start-journey.012162ad.png";